import { isoToDateString } from "./isoToDate";
import { isoToTimeString, isoToTimeStringS } from "./isoToTimeString";

const isoToDateTimeString = (value, defaultValue='') => {
  return `${isoToDateString(value, defaultValue)} ${isoToTimeString(value, defaultValue='')}`;
};


const isoToDateTimeStringS = (value, defaultValue='') => {
  return `${isoToDateString(value, defaultValue='')} ${isoToTimeStringS(value, defaultValue='')}`;
};

export {
  isoToDateTimeString,
  isoToDateTimeStringS
};